import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'
import Utils from '../../providers/Utils';
import ProgramatorLuniTable from '../monthComponent/ProgramatorLuniTable';
import ConcediuLuni from '../monthComponent/ConcediuLuni';
import OreLucrate from '../OreLucrate';



 

export default class ProgramatorDialog extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                fullScreen={true}
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                    <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 {this.props.scop === 'concediu' &&
                 <ConcediuLuni
                 openConcediuDialogInsert={this.props.openConcediuDialogInsert}
                 openConcediuDialogUpdate={this.props.openConcediuDialogUpdate}
                 luna={this.props.luna}
                 anul ={this.props.anul}
                 angajati={this.props.angajati}
                 minusLuna={this.props.minusLuna}
                 plusLuna={this.props.plusLuna}
                pontajeAll={this.props.pontaje}
                departament={this.props.departament}
                changeDepartament={this.props.changeDepartament}
                departamente={this.props.departamente}
                
                />
                }
                {this.props.scop === 'angajati' &&
                     <ProgramatorLuniTable 
                     luna={this.props.luna}
                     anul ={this.props.anul}
                     angajati={this.props.angajati}
                     minusLuna={this.props.minusLuna}
                     plusLuna={this.props.plusLuna}
                    pontajeAll={this.props.pontaje} 
                    departament={this.props.departament}
                    changeDepartament={this.props.changeDepartament}
                    departamente={this.props.departamente}
                    />
              }

              {this.props.scop === 'orelucru' &&
                <OreLucrate
                  luna={this.props.luna}
                  anul ={this.props.anul}
                  angajati={this.props.angajati}
                  minusLuna={this.props.minusLuna}
                  plusLuna={this.props.plusLuna}
                pontajeAll={this.props.pontaje}/>
            }
         
                
                
                
                   
                 </Dialog>
         </div>
        );
       }
}